<template>
  <div @mouseleave="hover = false" @mouseover="hover = true"
       class="scroll-carousel" style="position: relative">

    <v-slide-group
      :value="value"
      @change="val => $emit('input', val)"
      :class="$vuetify.breakpoint.xs ? 'slideGroup py-0' : 'slideGroup py-4'"
      show-arrows
    >
      <v-slide-item
        class="mx-3"
        v-for="(item, index) in items"
        :key="item.id"
        v-slot="{ active, toggle }"
      >
        <slot :item="item" :index="index">{{ item }}</slot>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>

<script>
export default {
  name: 'fin-scroll-carousel',
  props: {
    items: {
      type: Array
    },
    value: {
      type: Number
    }
  },
  data() {
    return {
      hover: false
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group.v-item-group {
  .v-slide-group__next, .v-slide-group__prev {
    min-width: 26px !important;

    .v-icon {
      font-size: 40px;
      color: $fin-color-primary-dark !important;
    }

  }

  .v-slide-group__prev--disabled .v-icon {
    color: $fin-color-light-blue-gray !important;
  }


  .v-slide-group__next--disabled .v-icon {
    color: $fin-color-light-blue-gray !important;
  }
}

::v-deep .v-slide-group__content{
  margin-bottom: 12px;
}

.scroll-carousel{
  margin: 0px -10px;
}

</style>
